import { axiosInstance } from "../utils/axios";

// Get user schedule
export const getUserScheduleApi = async (page, limit = 12) => {
  return await axiosInstance.get(`/meeting-hub/schedules?page=${page}&limit=${limit}`);
};

// Get a single schedule by id (used for the ?meeting=<id> deep link).
export const getScheduleByIdApi = async (meetingId) => {
  return await axiosInstance.get(`/meeting-hub/schedules/${meetingId}`);
};

// Get the current user's invitations (used for the "Meeting Requests" list).
export const getInvitationsApi = async () => {
  return await axiosInstance.get(`/meeting-hub/invitations`);
};

// accept decline meeting API
export const acceptDeclineMeetingApi = async (answer, meetingId) => {
  return await axiosInstance.post(`/meeting-hub/invitations/respond`, {
    status: answer,
    scheduleId: meetingId,
  });
};

// Reschedule API
export const rescheduleMeetingApi = async (meetingId, data) => {
  return await axiosInstance.put(`/meeting-hub/schedules/${meetingId}`, {
    ...data,
  });
};

// Ask For Reschedule API — invitee proposes a NEW start + end time.
export const askForRescheduleApi = async (meetingId, startDate, endDate) => {
  return await axiosInstance.post(`/meeting-hub/schedules/ask-reschedule`, {
    scheduleId: meetingId,
    startDate,
    endDate,
  });
};

// Respond to a reschedule request (owner) — action: "accept" | "decline".
export const respondRescheduleApi = async (meetingId, action) => {
  return await axiosInstance.post(`/meeting-hub/schedules/respond-reschedule`, {
    scheduleId: meetingId,
    action,
  });
};

// Add Schedule API
export const addScheduleApi = async (data) => {
  return await axiosInstance.post(`/meeting-hub/schedules`, data);
};

// Cancel Meeting API (owner only) — soft-cancels the schedule and notifies invitees.
export const cancelMeetingApi = async (meetingId) => {
  return await axiosInstance.post(`/meeting-hub/schedules/${meetingId}/cancel`);
};

// Get all schedule
export const getAllScheduleApi = async () => {
  return await axiosInstance.get(`/schedules`);
};
